// Auto-generated file. Do not edit manually.
// Generated by scripts/generate-screenshots.ts

export const PRODUCT_SCREENSHOTS = {
  "reddit-scout-pro": [
    {
      type: "image",
      src: "/product/reddit-scout-pro/screenshot-1.png",
      alt: "Screenshot 1",
    },
    {
      type: "image",
      src: "/product/reddit-scout-pro/screenshot-2.png",
      alt: "Screenshot 2",
    },
    {
      type: "image",
      src: "/product/reddit-scout-pro/screenshot-3.png",
      alt: "Screenshot 3",
    },
    {
      type: "image",
      src: "/product/reddit-scout-pro/screenshot-4.png",
      alt: "Screenshot 4",
    },
    {
      type: "image",
      src: "/product/reddit-scout-pro/screenshot-5.png",
      alt: "Screenshot 5",
    },
  ],
  "prompt-anything-pro": [
    {
      type: "image",
      src: "/product/prompt-anything-pro/screenshot-1.png",
      alt: "Screenshot 1",
    },
    {
      type: "image",
      src: "/product/prompt-anything-pro/screenshot-2.png",
      alt: "Screenshot 2",
    },
    {
      type: "image",
      src: "/product/prompt-anything-pro/screenshot-3.png",
      alt: "Screenshot 3",
    },
    {
      type: "image",
      src: "/product/prompt-anything-pro/screenshot-4.png",
      alt: "Screenshot 4",
    },
    {
      type: "image",
      src: "/product/prompt-anything-pro/screenshot-5.png",
      alt: "Screenshot 5",
    },
  ],
  "instagram-unfollow-pro": [
    {
      type: "image",
      src: "/product/instagram-unfollow-pro/screenshot-1.png",
      alt: "Screenshot 1",
    },
    {
      type: "image",
      src: "/product/instagram-unfollow-pro/screenshot-2.png",
      alt: "Screenshot 2",
    },
    {
      type: "image",
      src: "/product/instagram-unfollow-pro/screenshot-3.png",
      alt: "Screenshot 3",
    },
    {
      type: "image",
      src: "/product/instagram-unfollow-pro/screenshot-4.png",
      alt: "Screenshot 4",
    },
    {
      type: "image",
      src: "/product/instagram-unfollow-pro/screenshot-5.png",
      alt: "Screenshot 5",
    },
  ],
  "instagram-followers-exporter-pro": [
    {
      type: "image",
      src: "/product/instagram-followers-exporter-pro/screenshot-1.png",
      alt: "Screenshot 1",
    },
    {
      type: "image",
      src: "/product/instagram-followers-exporter-pro/screenshot-2.png",
      alt: "Screenshot 2",
    },
    {
      type: "image",
      src: "/product/instagram-followers-exporter-pro/screenshot-3.png",
      alt: "Screenshot 3",
    },
    {
      type: "image",
      src: "/product/instagram-followers-exporter-pro/screenshot-4.png",
      alt: "Screenshot 4",
    },
    {
      type: "image",
      src: "/product/instagram-followers-exporter-pro/screenshot-5.png",
      alt: "Screenshot 5",
    },
  ],
  "linkedin-connection-remover-pro": [
    {
      type: "image",
      src: "/product/linkedin-connection-remover-pro/screenshot-1.png",
      alt: "Screenshot 1",
    },
    {
      type: "image",
      src: "/product/linkedin-connection-remover-pro/screenshot-2.png",
      alt: "Screenshot 2",
    },
    {
      type: "image",
      src: "/product/linkedin-connection-remover-pro/screenshot-3.png",
      alt: "Screenshot 3",
    },
    {
      type: "image",
      src: "/product/linkedin-connection-remover-pro/screenshot-4.png",
      alt: "Screenshot 4",
    },
    {
      type: "image",
      src: "/product/linkedin-connection-remover-pro/screenshot-5.png",
      alt: "Screenshot 5",
    },
  ],
  "x-unfollow-pro": [
    {
      type: "image",
      src: "/product/x-unfollow-pro/screenshot-1.png",
      alt: "Screenshot 1",
    },
    {
      type: "image",
      src: "/product/x-unfollow-pro/screenshot-2.png",
      alt: "Screenshot 2",
    },
    {
      type: "image",
      src: "/product/x-unfollow-pro/screenshot-3.png",
      alt: "Screenshot 3",
    },
    {
      type: "image",
      src: "/product/x-unfollow-pro/screenshot-4.png",
      alt: "Screenshot 4",
    },
    {
      type: "image",
      src: "/product/x-unfollow-pro/screenshot-5.png",
      alt: "Screenshot 5",
    },
  ],
  "x-followers-exporter-pro": [
    {
      type: "image",
      src: "/product/x-followers-exporter-pro/screenshot-1.png",
      alt: "Screenshot 1",
    },
    {
      type: "image",
      src: "/product/x-followers-exporter-pro/screenshot-2.png",
      alt: "Screenshot 2",
    },
    {
      type: "image",
      src: "/product/x-followers-exporter-pro/screenshot-3.png",
      alt: "Screenshot 3",
    },
    {
      type: "image",
      src: "/product/x-followers-exporter-pro/screenshot-4.png",
      alt: "Screenshot 4",
    },
    {
      type: "image",
      src: "/product/x-followers-exporter-pro/screenshot-5.png",
      alt: "Screenshot 5",
    },
  ],
  "video-downloader-pro": [
    {
      type: "image",
      src: "/product/video-downloader-pro/screenshot-1.png",
      alt: "Screenshot 1",
    },
    {
      type: "image",
      src: "/product/video-downloader-pro/screenshot-2.png",
      alt: "Screenshot 2",
    },
    {
      type: "image",
      src: "/product/video-downloader-pro/screenshot-3.png",
      alt: "Screenshot 3",
    },
    {
      type: "image",
      src: "/product/video-downloader-pro/screenshot-4.png",
      alt: "Screenshot 4",
    },
    {
      type: "image",
      src: "/product/video-downloader-pro/screenshot-5.png",
      alt: "Screenshot 5",
    },
  ],
  "readmonkey-pro": [
    {
      type: "image",
      src: "/product/readmonkey-pro/screenshot-1.png",
      alt: "Screenshot 1",
    },
    {
      type: "image",
      src: "/product/readmonkey-pro/screenshot-2.png",
      alt: "Screenshot 2",
    },
    {
      type: "image",
      src: "/product/readmonkey-pro/screenshot-3.png",
      alt: "Screenshot 3",
    },
    {
      type: "image",
      src: "/product/readmonkey-pro/screenshot-4.png",
      alt: "Screenshot 4",
    },
    {
      type: "image",
      src: "/product/readmonkey-pro/screenshot-5.png",
      alt: "Screenshot 5",
    },
  ],
} as const;

export type ProductScreenshots = typeof PRODUCT_SCREENSHOTS;
